import styled, { css } from 'styled-components';
import { tileTokens } from '../../tokens/components/Tile/tokens';

const variantColors = {
  default: tileTokens.BackgroundColorBaseDefault,
  'accent-1': tileTokens.BackgroundColorAccent1Default,
  'accent-2': tileTokens.BackgroundColorAccent2Default,
  'accent-3': tileTokens.BackgroundColorAccent3Default,
  'accent-4': tileTokens.BackgroundColorAccent4Default,
};

/*
  Theses values are the same as the ones used in other spacing components, but
  they do not match the nomenclature used in spacing tokens, so they are not
  being used here.
*/
const spacingValues = {
  none: 0,
  xsmall: '4px',
  4: '4px',
  small: '8px',
  8: '8px',
  10: '10px',
  medium: '12px',
  12: '12px',
  large: '16px',
  16: '16px',
  gutter: '20px',
  20: '20px',
  24: '24px',
  xlarge: '32px',
  32: '32px',
  48: '48px',
};

/* @internal */
export const StyledTile = styled.div`
  padding: ${({ theme }) => spacingValues[theme.spacing] ?? theme.spacing};

  ${({ theme }) =>
    theme.tileVariant &&
    css`
      background-color: ${variantColors[theme.tileVariant]};
      border-color: transparent;
      border-style: ${tileTokens.BorderStyleBaseDefault};
      border-width: ${tileTokens.BorderWidthBaseDefault};
    `}

  ${({ theme }) =>
    theme.tileVariant === 'default' &&
    css`
      border-color: ${tileTokens.BorderColorBaseDefault};
      border-style: ${tileTokens.BorderStyleBaseDefault};
      border-width: ${tileTokens.BorderWidthBaseDefault};
    `}

  border-radius: ${tileTokens.BorderRadiusBaseDefault};
  margin-bottom: ${tileTokens.SpacingBaseDefault};

  &:last-child {
    margin-bottom: 0;
  }

  ${({ theme }) =>
    theme.height === 'full' &&
    css`
      height: 100%;
    `};

  ${({ theme }) =>
    theme.trim &&
    css`
      margin-bottom: 0;
    `};
`;
